theme.SlideShow = (function () {
  function Slider(e) {
    let slideshow = e.querySelector(".slideshow__wrapper"),
      paginationSelector = e.querySelector(".swiper-pagination"),
      navselectorPrev = e.querySelector(".swiper-button-prev"),
      navselectorNext = e.querySelector(".swiper-button-next"),
      autoplaySelctor = e.dataset.sliderAutoplay,
      autoplayInit = false,
      autoPlayDelay = parseInt(e.dataset.sliderDelay),
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      slidePagination = e.dataset.pagination,
      paginatinInit = "bullets";
    
    // Set up text elements for animation - adding this line to target all text wrappers
    const slideTextElements = e.querySelectorAll('.slideshow__text-wrapper');
    
    if (autoplaySelctor == "true") {
      autoplayInit = { delay: autoPlayDelay };
    }
    if (loopSelector == "true") {
      loopInit = true;
    }
    if (slidePagination == "counter") {
      paginatinInit = "fraction";
    }
    
    var swiper = new Swiper(slideshow, {
      loop: loopInit,
      pagination: {
        el: paginationSelector,
        clickable: true,
        type: paginatinInit,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
      autoplay: autoplayInit,
      autoHeight: false,
      speed: 800,
      navigation: {
        nextEl: navselectorNext,
        prevEl: navselectorPrev,
      },
      
      // Add effect configuration
      // effect: "creative",
      // creativeEffect: {
      //   prev: {
      //     shadow: true,
      //     translate: ["-80%", 0, -1],
      //   },
      //   next: {
      //     translate: ["100%", 0, 0],
      //   },
      // },
      
      // Add event handlers for slide animations
      on: {
        init: function() {
          // Set initial state for first slide
          const activeSlide = this.slides[this.activeIndex];
          if (activeSlide) {
            const activeText = activeSlide.querySelector('.slideshow__text-wrapper');
            if (activeText) {
              activeText.classList.add('animate-active');
            }
          }
        },
        slideChangeTransitionStart: function() {
          // Remove animation class from all slides
          slideTextElements.forEach(el => {
            el.classList.remove('animate-active');
          });
        },
        slideChangeTransitionEnd: function() {
          // Add animation class to active slide
          const activeSlide = this.slides[this.activeIndex];
          if (activeSlide) {
            const activeText = activeSlide.querySelector('.slideshow__text-wrapper');
            if (activeText) {
              activeText.classList.add('animate-active');
            }
          }
        }
      }
    });
    
    // For Shopify theme editor integration
    if (Shopify.designMode) {
      // Listen for Shopify theme editor events
      document.addEventListener('shopify:block:select', function(event) {
        // Check if the selected block belongs to this slideshow
        if (e.contains(event.target) || event.target.closest('[data-section-id]') === e.closest('[data-section-id]')) {
          // Find the index of the selected slide
          const slides = slideshow.querySelectorAll('.swiper-slide');
          let selectedIndex = 0;
          
          slides.forEach((slide, index) => {
            if (slide === event.target || slide.contains(event.target)) {
              selectedIndex = index;
              
              // Immediately show the text for the selected slide in the editor
              const textElement = slide.querySelector('.slideshow__text-wrapper');
              if (textElement) {
                slideTextElements.forEach(el => {
                  el.classList.remove('animate-active');
                });
                textElement.classList.add('animate-active');
              }
            }
          });
          
          // Navigate to the selected slide
          swiper.slideTo(selectedIndex);
          
          // Pause autoplay when editing in the theme editor
          if (swiper.autoplay && swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
        }
      });
      
      // Resume autoplay when deselecting blocks (if autoplay was enabled)
      document.addEventListener('shopify:block:deselect', function(event) {
        if (e.contains(event.target) || event.target.closest('[data-section-id]') === e.closest('[data-section-id]')) {
          if (autoplayInit && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        }
      });
      
      // Handle section selection in the theme editor
      document.addEventListener('shopify:section:select', function(event) {
        if (event.target.contains(e) || event.target === e) {
          if (autoplayInit && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
        }
      });
      
      // Handle section deselection in the theme editor
      document.addEventListener('shopify:section:deselect', function(event) {
        if (event.target.contains(e) || event.target === e) {
          if (autoplayInit && swiper.autoplay && !swiper.autoplay.running) {
            swiper.autoplay.start();
          }
        }
      });
    }
  }
  return Slider;
})();